const { createContext } = require("react");

export const contextNews = createContext({
    isReadLatestNews: true,
    setisReadLatestNews: ()=>{},
})